module.exports = __webpack_public_path__ + "img/page_not_found.15af06fa.svg";